import { useNavigate } from "react-router-dom";

export const useHandleNavigation = () => {
  const navigate = useNavigate();

  return (to: string, state?: any) => {
    navigate(to, { state });
  };
};
